import { render, staticRenderFns } from "./VideoModal.vue?vue&type=template&id=37fca891&"
import script from "./VideoModal.vue?vue&type=script&lang=ts&"
export * from "./VideoModal.vue?vue&type=script&lang=ts&"
import style0 from "./VideoModal.vue?vue&type=style&index=0&id=37fca891&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports